import * as React from "react";
import styled from "@mui/material/styles/styled";
import { FeatureUtil } from "../util/featureUtil";
import { LevelSelectComponent } from "../common/LevelSelectComponent";
import { YesNoButtonComponent } from "../common/YesNoButtonComponent";
import { QualifiedFeature } from "fe-common/graphql";
import {
  DataInput,
  DataInputPanel,
  extractResponseFromQF,
} from "../../dataInputTypes";
import { Suggestion } from "../hooks/useSuggestions";

//region [[ Styles ]]

const ItemEditComponentView = styled("div")(({ theme }) => ({}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ItemEditComponentProps {
  qf: QualifiedFeature;
  selectionValue?: DataInput;
  onChange: (resp: DataInput) => void;
  panel?: DataInputPanel;
  suggestion: Suggestion;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ItemEditComponent = ({ ...props }: ItemEditComponentProps) => {
  return (
    <ItemEditComponentView>
      {FeatureUtil.findingUsesLevel(props.qf) ? (
        <LevelSelectComponent
          qf={props.qf}
          onChange={props.onChange}
          response={
            props.selectionValue
              ? props.selectionValue
              : extractResponseFromQF(props.qf)
          }
        />
      ) : (
        <YesNoButtonComponent
          qf={props.qf}
          onChange={props.onChange}
          allowDeselect={true}
          disabled={false}
          response={
            props.selectionValue
              ? props.selectionValue
              : extractResponseFromQF(props.qf)
          }
        />
      )}
    </ItemEditComponentView>
  );
};
